
import { Vue, Options } from "vue-class-component";
@Options({
  props: {
    title: String
  },
  emits: {
    moreaction: () => {
      return true;
    }
  }
})
export default class LotteryMore extends Vue {}
